export default __webpack_public_path__ + "static/media/user_gold.2f6246ea.svg";